import { FormHiddenTextField, FormTextFieldProps } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props extends Omit<FormTextFieldProps, "name"> {
  name?: string;
}

export const FormTextFieldPassword = ({ name = "password", label, placeholder, fullWidth, ...props }: Props) => {
  const { t } = useTranslation(["common"]);

  return (
    <FormHiddenTextField
      fullWidth={fullWidth ?? true}
      label={label ?? t("common:form.text.field.password.label")}
      name={name}
      placeholder={placeholder ?? t("common:form.text.field.password.placeholder")}
      {...props}
    />
  );
};
